import { apiClient } from './axios';

import type { OutcomeDefinition, OutcomeDefinitionInput } from '@repo/shared-types';

export type { OutcomeDefinition, OutcomeDefinitionInput };

export const outcomesApi = {
  /** All definitions (management view). */
  async list(params?: { activeOnly?: boolean }) {
    const { data } = await apiClient.get<OutcomeDefinition[]>('/outcomes', {
      params: params?.activeOnly ? { activeOnly: 'true' } : {},
    });
    return data;
  },

  /** Active platform-wide outcome vocabulary. */
  async effective() {
    const { data } = await apiClient.get<OutcomeDefinition[]>('/outcomes/effective');
    return data;
  },

  async create(input: OutcomeDefinitionInput) {
    const { data } = await apiClient.post<OutcomeDefinition>('/outcomes', input);
    return data;
  },

  async update(id: string, input: Partial<OutcomeDefinitionInput>) {
    const { data } = await apiClient.patch<OutcomeDefinition>(`/outcomes/${id}`, input);
    return data;
  },

  /** Soft delete — deactivates the definition. */
  async deactivate(id: string) {
    const { data } = await apiClient.delete<OutcomeDefinition>(`/outcomes/${id}`);
    return data;
  },
};
